export const salesNames: string[] = [
  'María',
  'Patricia',
  'Lucía',
  'Carmen',
  'Andrea',
  'Daniela',
  'Rocío',
  'Verónica',
  'Marta',
  'Camila',
  'Fernanda',
  'Alejandra',
  'Silvia',
  'Noelia',
  'Julia',
  'Carolina',
  'Pilar',
  'Ana',
  'Cristina',
  'Marcela',
  'Inés',
  'Teresa',
  'Lorena',
  'Yolanda',
  'Débora',
  'Susana',
  'Ximena',
  'Renata',
  'Adriana',
  'Estefanía',
]
